var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"calendar-search-preview",class:( _obj = {}, _obj[_vm.classForViewRound] = true, _obj[_vm.textColor] = true, _obj ),attrs:{"color":_vm.backgroundColor,"elevation":"1"}},[_c('v-text-field',{attrs:{"placeholder":_vm.$trans('search'),"background-color":"transparent","flat":"","hide-details":"","readonly":"","solo":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }